import {LocalStorage} from "./LocalStorage";

export class Dictionary {
    private storage: LocalStorage = new LocalStorage();

    private static _language: string | null = null;
    private static _languages: string[] | null = null;
    private static _dictionary: { [key: string]: string } | null = null;
    private static _dictionaryVersion: string | null = null;
    private static _handledLanguages: string[] | null = null;

    public get: any;

    constructor() {
        this.get = new Proxy(this, {
            get: function (dictionary, key: string) {
                if (Dictionary._dictionary === null) {
                    Dictionary._dictionary = dictionary.storage.get('dictionary');
                    if (Dictionary._dictionary === null || dictionary.language === null) {
                        console.error('(#dictionary || #language) not set..');
                        return key;
                    }
                }
                if (typeof Dictionary._dictionary[key] !== 'undefined') {
                    return Dictionary._dictionary[key];
                }
                dictionary.pushEmptyKey(key);
                return key;
            }
        });
    }

    pushEmptyKey(key: string) {
        let keys = this.storage.get('dictionary.emptyKeys') || [];
        keys.push(key);
        this.storage.set('dictionary.emptyKeys', keys.filter((value: any, index: any, array: string | any[]) => {
            return array.indexOf(value) === index;
        }));
    }

    fetchEmptyKey(): string | null {
        let keys = this.storage.get('dictionary.emptyKeys') || [];
        const key = keys.shift();
        this.storage.set('dictionary.emptyKeys', keys);
        return key;
    }

    setUp(options: { dictionary: {}, user: {} } | any) {

        if ((options.dictionary ?? null) !== null) {
            this.language = options.language;
            this.languages = options.languages;
            this.handledLanguages = options.handledLanguages;
            this.dictionaryVersion = options.dictionaryVersion;
            this.storage.set('dictionary', Dictionary._dictionary = options.dictionary);
        }

        if (Dictionary._dictionary === null) {
            Dictionary._dictionary = this.storage.get('dictionary');
        }
    }

    get dictionaryVersion(): any | string {
        if (Dictionary._dictionary === null) {
            Dictionary._dictionary = this.storage.get('dictionary');
        }
        if (Dictionary._dictionary === null || this.languages === null || this.handledLanguages === null) {
            return null;
        }
        if (Dictionary._dictionaryVersion) {
            return Dictionary._dictionaryVersion;
        }
        return Dictionary._dictionaryVersion = this.storage.get('dictionary.version');
    }

    set dictionaryVersion(dictionaryVersion: string | null) {
        this.storage.set('dictionary.version', Dictionary._dictionaryVersion = dictionaryVersion);
    }

    public valid(): boolean {
        return typeof this.dictionaryVersion === 'string' && 0 < this.dictionaryVersion.length;
    }

    get language(): string {
        if (Dictionary._language) {
            return Dictionary._language;
        }
        return Dictionary._language = this.storage.get('language') || navigator.language;
    }

    getLocale() {
        return this.language + '-' + this.language.toUpperCase();
    }

    static PriceFormat(number: any, currency: any): string {
        if (typeof currency !== 'string' || currency.length === 0) {
            return number || '-';
        }
        return new Intl.NumberFormat((new Dictionary()).getLocale(), {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'HUF' ? 0 : 2,
            maximumFractionDigits: currency === 'HUF' ? 0 : 2,
        }).format(number);
    }

    set language(language: string) {
        this.storage.set('language', Dictionary._language = language);
        // @ts-ignore
        document.querySelector('html').setAttribute('lang', language);
    }

    get languages(): string[] {
        if (Dictionary._languages) {
            return Dictionary._languages;
        }
        return Dictionary._languages = this.storage.get('languages') || {};
    }

    set languages(languages: string[]) {
        this.storage.set('languages', Dictionary._languages = languages);
    }

    get handledLanguages(): string[] {
        if (Dictionary._handledLanguages) {
            return Dictionary._handledLanguages;
        }
        return Dictionary._handledLanguages = this.storage.get('handledLanguages') || [];
    }

    set handledLanguages(handledLanguages: string[]) {
        this.storage.set('handledLanguages', Dictionary._handledLanguages = handledLanguages);
    }

    translate(string: string) {
        let beg = '{{', end = '}}', dictionary: this = this;

        const matcher: RegExp = new RegExp(`${beg}(.*?)${end}`, 'gm');

        const normalise = (str: string) => str.slice(beg.length, end.length * -1);

        let match = string.match(matcher);

        if (match === null) {
            return string;
        }

        // @ts-ignore
        string.match(matcher).map(normalise).forEach(value => {
            if (Dictionary._dictionary === null) {
                Dictionary._dictionary = dictionary.storage.get('dictionary');
                if (Dictionary._dictionary === null || dictionary.language === null) {
                    console.error('(#dictionary || #language) not set..');
                    return string;
                }
            }

            if (typeof Dictionary._dictionary[value] === 'undefined') {
                dictionary.pushEmptyKey(value);
            } else {
                string = string.replace(`${beg}${value}${end}`, Dictionary._dictionary[value]);
            }
        });

        return string;
    }
}
